import React from 'react';
import {AppButton, AppButtonProps} from '../buttons';

export interface AppDialogFooterProps {
    onCancelClick?: () => void;
    onSubmitClick?: () => void;
    onCancelLabel?: string;
    onSubmitLabel?: string;
    submitButtonProps?: Omit<AppButtonProps, 'children'>;
    cancelButtonProps?: Omit<AppButtonProps, 'children'>;
}
export const AppDialogFooter: React.FC<AppDialogFooterProps> = ({
    onCancelClick,
    onCancelLabel = 'Cancel',
    onSubmitClick,
    onSubmitLabel = 'Save',
    submitButtonProps,
    cancelButtonProps,
}) => {
    return (
        <>
            <AppButton
                {...cancelButtonProps}
                onClick={() => {
                    if (onCancelClick) {
                        onCancelClick();
                    }
                }}
            >
                {onCancelLabel}
            </AppButton>
            <AppButton {...submitButtonProps} onClick={onSubmitClick}>
                {onSubmitLabel}
            </AppButton>
        </>
    );
};

export default AppDialogFooter;
